export const PAYMENT_ESTIMATE_DISCLAIMER =
  "Estimated payments based on program buy rate. Final payment will be determined at deal structuring.";
